import { FC, useCallback, useMemo, useState } from "react"
import {
  PageInfo,
  PageStackContext,
  PageStackContextValue,
} from "./_/PageStackContext"

export const PageStackProvider: FC = props => {
  const [pageStack, setPageStack] = useState<PageInfo[]>([])

  const pushPage = useCallback(page => {
    setPageStack(stack => stack.concat(page))
    return () => {
      setPageStack(stack => stack.filter(s => s !== page))
    }
  }, [])
  const ctxValue: PageStackContextValue = useMemo(
    () => ({
      pageStack,
      pushPage,
    }),
    [pageStack, pushPage],
  )

  return (
    <PageStackContext.Provider value={ctxValue}>
      {props.children}
    </PageStackContext.Provider>
  )
}
